// extracted by mini-css-extract-plugin
export var borderRadius = "_fj-4";
export var large = "_fj-3";
export var logoContainer = "_fj-0";
export var nameLogo = "_fj-2";
export var small = "_fj-1";